import React from "react"
import { concatStrings } from "../../utilities"
import { t } from "../../../i18n-utility"
import DfbCardIcons from "./dfb_card_icons"
import DfbHeadline from "../../ui-kit/dfb_headline"
import DfbAnchor from "../../ui-kit/dfb_anchor"
import PageContext from "../../page-context"
import DfbSymbol from "../../ui-kit/dfb_symbol"
import DfbImage from "../../ui-kit/dfb_image"
import { Transformation } from "cloudinary-react"
import CCardAuthor from "../c_card_author"
import DateFormat from "../../date_format"
import { isPageAccessRestricted } from "../../../helper/pageAccess.mjs"
import { withPrefix } from "gatsby"

const DfbContentImageCard = (props) => {
  const external_target =
    props.data.full_slug.indexOf("http://") !== -1 ||
    props.data.full_slug.indexOf("https://") !== -1
      ? { target: "_blank" }
      : {}
  return (
    <a
      className={concatStrings(
        "dfb-Card dfb-Card--contentImage",
        props.data.add_class
      )}
      href={withPrefix(props.data.full_slug)}
      {...external_target}
    >
      <DfbCardIcons data={props.data} />

      <div className="dfb-Card-content">
        <PageContext.Consumer>
          {({ translations }) => (
            <div className="dfb-Card-topline">
              {props.data.content.card_format_override &&
              props.data.content.card_format_override !== ""
                ? props.data.content.card_format_override
                : t(translations, `cards.${props.data.type}`)}
              {(props.data.type === "news" ||
                props.data.type === "trainercolumn") && (
                <DateFormat
                  singledate={props.data.starttime}
                  format="DD.MM.YYYY"
                />
              )}
            </div>
          )}
        </PageContext.Consumer>

        <DfbHeadline
          headline={props.data.title || props.data.name}
          noLevelClass="true"
          headline_level="h4"
          add_class="dfb-Card-headline"
        />

        {!props.data.hide_image && (
          <DfbImage
            image={
              typeof props.data.content.titleimage === "string" &&
              props.data.content.titleimage !== ""
                ? { src: props.data.content.titleimage }
                : props.data.content.titleimage
            }
            add_class="dfb-Card-contentImage"
            lazyload={props.force_image_loading ? false : true}
            aspect_ratio={
              props.data.image_aspect_ratio
                ? props.data.image_aspect_ratio
                : "16:9"
            }
          >
            <Transformation
              crop="fill"
              gravity="faces:center"
              width="800"
              height="450"
              quality="auto"
              fetchFormat="auto"
            />
          </DfbImage>
        )}

        {props.data.content.author &&
          props.data.content.author.show_on_card === 1 && (
            <CCardAuthor
              author={props.data.content.author}
              force_image_loading={props.force_image_loading}
            />
          )}

        {props.data.content.card_callout &&
          props.data.content.card_callout !== "" && (
            <div className="dfb-Card-disturber">
              <div className="dfb-Icon dfb-Card-disturberIcon">
                <DfbSymbol icon_type="Information" />
              </div>
              <p className="dfb-Card-disturberContent">
                {props.data.content.card_callout}
              </p>
            </div>
          )}
      </div>
      <div className="dfb-Card-footer">
        <PageContext.Consumer>
          {({ translations }) => (
            <DfbAnchor
              tagName="div"
              secondary={true}
              text={t(translations, "dfb_anchor.morelink")}
              locked={isPageAccessRestricted(props.data)}
            />
          )}
        </PageContext.Consumer>
      </div>
    </a>
  )
}

export default DfbContentImageCard
